import CreateFieldManager from './CreateFieldManager';

export default CreateFieldManager;
